<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
            <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">Invoice</h4>
              <button v-if="['finance','master_admin','admin'].includes(role)" class="float-right btn btn-primary shadow" v-on:click="formInvoiceLainActive=!formInvoiceLainActive">Tambah Invoice Baru</button>
            </div>
            <transition name="fade">
            <div class="col-12  my-2 py-0" v-if="formInvoiceLainActive">
                <div class="row p-3 mx-2 bg-white shadow">
                  <div class="col-12 mb-3">
                    <h4 class="my-0 py-0">Form Invoice</h4>
                    <hr>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-inline">Nama<span style="color:red;">*</span></label> 
                    <smart-search :search-value="newInvoiceLain.clientlabel" init url="/api/master/v2/seeker/application" usedefault :default-value="newInvoiceLain.clientlabel" key-tag="application_name" :label-tag="['application_name']" v-on:update="(data)=>{newInvoiceLain.client_id=data.id}"  @update-direct="(label)=>newInvoiceLain.clientlabel=label"></smart-search>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Status</label>
                    <smart-select name="status" :options="statusOptions" v-on:update="updateStatus"></smart-select>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">PPN</label>
                    <smart-select name="ppn" :options="ppnTypeOptions" v-on:update="updateNewPpn"></smart-select>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2" v-if="isPaid">
                    <label class="d-block">Invoice</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newInvoiceLain.invoice_no"/>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2" v-if="isUnpaid">
                    <label class="d-block">Proforma Invoice</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newInvoiceLain.invoice_proforma"/>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2 d-none">
                    <label class="d-block">Nama Admin</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newInvoiceLain.admin_name"/>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2" v-if="isPaid">
                    <label class="d-block">Tanggal Bayar</label>
                    <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-invoice-date" v-model="newInvoiceLain.invoice_date" class="mb-2">{{newInvoiceLain.invoice_date}}</b-form-datepicker>
                  </div>
                  <!-- <div class="col-12 col-md-6 col-lg-4 mt-2" v-if="isPaid">
                    <label class="d-block">Jatuh Tempo</label>
                    <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-due-date" v-model="newInvoiceLain.due_date" class="mb-2">{{newInvoiceLain.due_date}}</b-form-datepicker>
                  </div> -->
                  <div class="col-12 col-md-6 col-lg-4 mt-2" v-if="isUnpaid">
                    <label class="d-block">Tanggal Proforma Invoice</label>
                    <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-invoice-date-proforma" v-model="newInvoiceLain.invoice_date_proforma" class="mb-2">{{newInvoiceLain.invoice_date_proforma}}</b-form-datepicker>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2" v-if="isUnpaid">
                    <label class="d-block">Jatuh Tempo Proforma</label>
                    <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-due-date-proforma" v-model="newInvoiceLain.due_date_proforma" class="mb-2">{{newInvoiceLain.due_date_proforma}}</b-form-datepicker>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Akun Bank</label>
                    <smart-search 
                    :search-value="newInvoiceLain.label_bank" init url="/api/master/seeker/bank" usedefault :default-value="newInvoiceLain.label_bank" key-tag="nama" :label-tag="['no_rekening','nama']" v-on:update="(data)=>{newInvoiceLain.id_bank=data.id}"  @update-direct="(label)=>newInvoiceLain.label_bank=label"></smart-search>
                  </div>
                  <!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">PIC</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newInvoiceLain.pic" />
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Jabatan</label>
                    <input type="text" class="form-control w-100 rounded" v-model="newInvoiceLain.division" />
                  </div> -->
                  <div class="col-12 col-md-6 col-lg-6 mt-2">
                    <label class="d-block">Keterangan</label>
                    <textarea type="text"  class="form-control w-100 rounded" v-model="newInvoiceLain.notes" />
                  </div>
                  <div class="col-12 mt-2">
                    <br>
                    <b>List item:</b>
                    <hr>
                    <div class="row py-2" style="background:#f0f0f0" v-for="(item,index) in newInvoiceLain.items" v-bind:key="'newitem'+item.id">
                      <div class="col-12">
                        <button class="float-right btn btn-sm btn-danger bg-white" @click="newInvoiceLain.items.splice(index, 1);">hapus</button>
                      </div>
                      <div class="col-12 col-md-4">
                        <label class="d-block">Item</label>
                        <smart-search init url="/api/master/seeker/item-lain" :label-tag="['item_name']" key-tag="item_name" v-on:update="(data)=>{item.item_name=data.item_name;item.item_id=data.id;item.price=data.price;calculateAmount()}" :search-value="item.item_name" @update-direct="(label)=>item.item_name=label"></smart-search>
                      </div>
                      <div class="col-12 col-md-2">
                        <label class="d-block">Quantity</label>
                        <input type="number" class="form-control w-100 rounded" v-model="item.qty" @input="calculateAmount()" />
                      </div>
                      <div class="col-12 col-md-3">
                        <label class="d-block">Harga</label>
                      <div type="text" class="form-control w-100 rounded" >{{ item.price | numeral('0,0') }}</div>
                      </div>
                      <div class="col-12 col-md-3">
                        <label class="d-block">Total</label>
                      <div type="text" class="form-control w-100 rounded" >{{ item.price * item.qty | numeral('0,0') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-3">
                    <button class="float-right btn btn-secondary" @click="newInvoiceLain.items.push({item_id:-1,qty:1,price:0})">tambah</button>
                  </div>
                  
                  <div class="col-12 mt-2">
                    <br><br>
                    <hr>
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Harga</label>
                      <div type="text"  class="form-control col-12 col-md-6  text-right w-100 rounded">
                        {{ newInvoiceLain.subtotal | numeral('0,0') }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-2">
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Diskon</label>
                      <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                         -{{ newInvoiceLain.discount | numeral('0,0') }}
                      </div>
                    </div>  
                  </div>
                  <div class="col-12 mt-2">
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Sub total</label>
                      <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                         {{ newInvoiceLain.subtotal | numeral('0,0') }}
                      </div>
                    </div>  
                  </div>
                  <div class="col-12 mt-2">
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Total PPN</label>
                      <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                         {{ newInvoiceLain.totalPPN | numeral('0,0') }}
                      </div>
                    </div>  
                  </div>
                  <div class="col-12 mt-2">
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Total</label>
                      <div type="text"  class="form-control w-100 col-12 text-right col-md-6 rounded">
                         <b>{{ newInvoiceLain.total | numeral('0,0') }}</b>
                      </div>
                    </div>  
                  </div>
                  <div class="col-12 mt-3">
                      <div class="w-100 align-items-center justify-content-start" v-if="newInvoiceLainSaved">
                          <div class="alert alert-success" role="alert">
                              Berhasil Menyimpan Invoice Baru.
                          </div>
                      </div>
                  </div>
                    
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorNewInvoiceLain">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">Gagal Menyimpan Invoice Baru.</p>
                                </div>
                                <div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="savingNewInvoiceLain">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <button class="btn btn-primary float-right" type="button" v-on:click="savenewInvoiceLain">Submit</button>
                    </div>
                </div>
            </div>
            </transition>

        
          <div class="col-12  my-2 py-0">
            <datatable :currentIdx="currentPage" :lang="dicts.lang" :datas="invoiceitems"
                      :structure="tableStructure" :init="loadData" 
                      :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
                      use-filter use-seeker seeker-url="/api/pemesanan/seeker/invoice-lain"
                      xml-url="/api/xml/invoice-lain"
                     @refetch="(row)=>{rowLimit=row;getInvoiceLains()}"
                     @searching="(val)=>!val.status?getInvoiceLains():setInvoiceLains(val)">
                <template #customcell={obj,index}>
                    <td>{{ index+ 1 }}</td>
                    <td>{{ obj.invoice_no != null? obj.invoice_no:'-'}}</td>
                    <!-- <td>{{ obj.invoice_proforma != null? obj.invoice_proforma:'-'}}</td> -->
                    <td>{{ obj.client != null? obj.client.application.application_name:'-'}}</td>
                    <td>{{ obj.client != null? obj.client.application.id_client:'-'}}</td>
                    <td>{{ obj.metadata && obj.metadata.length > 0 ? obj.metadata[0].item_name : '-'}}</td>
                    <td>{{ obj.invoice_date | timeformat}}</td>
                    <!-- <td>{{ obj.due_date | timeformat}}</td> -->
                    <td>{{ obj.invoice_date_proforma | timeformat}}</td>
                    <td>{{ obj.due_date_proforma | timeformat}}</td>
                    <td>
                        <span :class="getStatusClass(obj.status)">
                        {{ translateStatus(obj.status) }}
                    </span>
                    </td>
                    <!-- <td>
                      <b-button  v-b-modal.modal-sap class="btn btn-success" :href="'https://mspapi.blck.id/api/invoice/airtime-sap/'+obj.id"><b>SAP</b></b-button>
                    </td> -->
                    <td>
                        <b-button title="Cetak Invoice" class="btn btn-warning mr-2 mb-1" :href="'https://api-billing.openfiber.co.id/api/invoice/lain/'+obj.id+'?qr=yes'"><b-icon icon="printer"></b-icon></b-button>
                        <b-button title="Cetak Proforma Invoice" class="btn btn-secondary mr-2 mb-1" :href="'https://api-billing.openfiber.co.id/api/invoice/unpaid/'+obj.id+'?proforma=yes&qr=yes'"><b-icon icon="printer"></b-icon></b-button>
                        <b-button title="Buat Invoice" v-b-modal.modal-add-invoice class="btn btn-success mr-2 mb-1" v-on:click="selectedIdforEdit=index" v-if="['master_admin','admin','finance'].includes(role)"><b-icon icon="file-earmark-plus"></b-icon></b-button>
                        <b-button title="Edit" v-b-modal.modal-edit-invoice class="btn btn-info mr-2 mb-1" v-on:click="selectedIdforEdit=index" v-if="['master_admin','admin','finance'].includes(role)"><b-icon icon="pencil-square"></b-icon></b-button>
                        <b-button title="Detail"  v-b-modal.modal-detail-invoice-lain class="btn btn-primary mr-2 mb-1" v-on:click="selectedDetail=index"><b-icon icon="eye"></b-icon></b-button>
                        <b-button title="Hapus" v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"  class="btn btn-danger mr-2 mb-1" v-if="['master_admin','admin'].includes(role)"><b-icon icon="trash"></b-icon></b-button>
                    </td>
                </template>
            </datatable>
          </div>

        <b-modal id="modal-edit-invoice" title="Edit data" no-close-on-backdrop size="lg"
                 @hide="editModalClose" v-if="invoiceitems.length>0">
                 <div class="row" v-if="invoiceitems[selectedIdforEdit]!=undefined">
                    <div class="col-12 col-md-6 mt-2">
                      <label class="d-inline">Nama<span style="color:red;">*</span></label> 
                      <smart-search :search-value="newInvoiceLain.clientlabel" init url="/api/inventaris/seeker/hardware-setup-v2" usedefault :default-value="invoiceitems[selectedIdforEdit].client.application.application_name" key-tag="id" :label-tag="['application_name']" v-on:update="(data)=>{invoiceitems[selectedIdforEdit].client_id=data.id}"  @update-direct="(label)=>newInvoiceLain.clientlabel=label"></smart-search>
                    </div>
                    <!-- <div class="col-12 col-md-6 mt-2">
                      <label class="d-block">Invoice</label>
                      <input type="text"  class="form-control w-100 rounded" v-model="invoiceitems[selectedIdforEdit].invoice_no"/>
                    </div> -->
                    <div class="col-12 col-md-6 mt-2">
                      <label class="d-block">Proforma Invoice</label>
                      <input type="text"  class="form-control w-100 rounded" v-model="invoiceitems[selectedIdforEdit].invoice_proforma"/>
                    </div>
                    <!-- <div class="col-12 col-md-6 mt-2">
                      <label class="d-block">Tanggal invoice</label>
                      <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-invoice-date-update" v-model="invoiceitems[selectedIdforEdit].invoice_date" class="mb-2">{{newInvoiceLain.invoice_date}}</b-form-datepicker>
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                      <label class="d-block">Jatuh tempo</label>
                      <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-due-date-update" v-model="invoiceitems[selectedIdforEdit].due_date" class="mb-2">{{newInvoiceLain.due_date}}</b-form-datepicker>
                    </div> -->
                    <div class="col-12 col-md-6 mt-2">
                      <label class="d-block">Tanggal Proforma Invoice</label>
                      <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-invoice-date-update-proforma" v-model="invoiceitems[selectedIdforEdit].invoice_date_proforma" class="mb-2">{{newInvoiceLain.invoice_date_proforma}}</b-form-datepicker>
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                      <label class="d-block">Jatuh Tempo Proforma</label>
                      <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-due-date-update-proforma" v-model="invoiceitems[selectedIdforEdit].due_date_proforma" class="mb-2">{{newInvoiceLain.due_date_proforma}}</b-form-datepicker>
                    </div>
                    <!-- <div class="col-12 col-md-6 mt-2">
                      <label class="d-block">PPN</label>
                      <smart-select name="ppn" :options="ppnTypeOptions" v-on:update="invoiceitems[selectedIdforEdit].ppn"></smart-select>
                    </div> -->
                    <div class="col-12 col-md-6 mt-2">
                      <label class="d-block">Akun Bank</label>
                      <smart-search 
                      :search-value="newInvoiceLain.label_bank" init url="/api/master/seeker/bank" usedefault :default-value="invoiceitems[selectedIdforEdit].bank == null ?'' : invoiceitems[selectedIdforEdit].bank.nama" key-tag="nama" v-on:update="(data)=>{invoiceitems[selectedIdforEdit].id_bank=data.id}"  @update-direct="(label)=>newInvoiceLain.label_bank=label"></smart-search>
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                      <label class="d-block">Keterangan</label>
                      <textarea type="text"  class="form-control w-100 rounded" v-model="invoiceitems[selectedIdforEdit].notes" />
                    </div>

                    <!-- <div class="col-12 mt-2">
                      <br>
                      <b>List item:</b>
                      <hr>
                      <div class="row py-2" style="background:#f0f0f0" v-for="(item,index) in invoiceitems[selectedIdforEdit].metadata" v-bind:key="'newitem'+item.id">
                        <div class="col-12">
                          <button class="float-right btn btn-sm btn-danger bg-white" @click="newInvoiceLain.items.splice(index, 1);">hapus</button>
                        </div>
                        <div class="col-12 col-md-4">
                          <label class="d-block">Item</label>
                          <smart-search 
                            usedefault :default-value="item.item_name" 
                            init url="/api/master/seeker/item-lain" :label-tag="['item_name']" key-tag="item_name" v-on:update="(data)=>{item.item_name=data.item_name;item.item_id=data.id;item.price=data.price;calculateUpdateAmount()}" :search-value="item.item_name" @update-direct="(label)=>item.item_name=label"></smart-search>
                        </div>
                        <div class="col-12 col-md-2">
                          <label class="d-block">Quantity</label>
                          <input type="number" class="form-control w-100 rounded" v-model="item.qty" @input="calculateUpdateAmount()" />
                        </div>
                        <div class="col-12 col-md-3">
                          <label class="d-block">Harga</label>
                        <div type="text" class="form-control w-100 rounded" >{{ item.price | numeral('0,0') }}</div>
                        </div>
                        <div class="col-12 col-md-3">
                          <label class="d-block">Total</label>
                        <div type="text" class="form-control w-100 rounded" >{{ item.price * item.qty | numeral('0,0') }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-3">
                      <button class="float-right btn btn-secondary" @click="newInvoiceLain.items.push({item_id:-1,qty:1,price:0})">tambah</button>
                    </div>
                    
                    <div class="col-12 mt-2">
                      <br><br>
                      <hr>
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Harga</label>
                        <div type="text"  class="form-control col-12 col-md-6  text-right w-100 rounded">
                          {{ invoiceitems[selectedIdforEdit].subtotal | numeral('0,0') }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-2">
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Diskon</label>
                        <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                           -{{ invoiceitems[selectedIdforEdit].discount | numeral('0,0') }}
                        </div>
                      </div>  
                    </div>
                    <div class="col-12 mt-2">
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Sub total</label>
                        <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                           {{ invoiceitems[selectedIdforEdit].subtotal | numeral('0,0') }}
                        </div>
                      </div>  
                    </div>
                    <div class="col-12 mt-2">
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Total PPN</label>
                        <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                           {{ invoiceitems[selectedIdforEdit].subtotal/10 | numeral('0,0') }}
                        </div>
                      </div>  
                    </div>
                    <div class="col-12 mt-2">
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Total</label>
                        <div type="text"  class="form-control w-100 col-12 text-right col-md-6 rounded">
                           <b>{{ invoiceitems[selectedIdforEdit].total | numeral('0,0') }}</b>
                        </div>
                      </div>  
                    </div> -->
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
                            <div class="alert alert-success" role="alert">
                                Berhasil Menyimpan Invoice Baru.
                            </div>
                        </div>
                    </div>
                      
                      <div class="col-12 mt-3">
                          <div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
                              <div class="alert alert-danger" role="alert">
                                  <div class="my-0">
                                      <p  class="d-block mt-1">Gagal Menyimpan Invoice Baru.</p>
                                  </div>
                                  <div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
                                      <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-12 mt-3">
                          <div class="d-flex align-items-center justify-content-start" v-if="savingNewInvoiceLain">
                              <div class="spinner-border" role="status" aria-hidden="true"></div>
                              <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                          </div>
                      </div>
                  </div>
              <!-- <div class="row" v-if="invoiceitems[selectedIdforEdit]!=undefined">
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.so[dicts.lang] }}</label>
                  <div class="form-control w-100 rounded">
                    {{
                      invoiceitems[selectedIdforEdit].sales_order != undefined && invoiceitems[selectedIdforEdit].sales_order != null ? invoiceitems[selectedIdforEdit].sales_order.order_number : "-"
                    }}
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.no_invoice[dicts.lang] }}</label>
                  <input type="text" class="form-control w-100 rounded"
                         v-model="invoiceitems[selectedIdforEdit].invoice_no"/>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.invoice_date[dicts.lang] }}</label>
                  <b-form-datepicker today-button reset-button close-button locale="id"
                                     :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
                                     id="datepicker-invoice-date"
                                     v-model="invoiceitems[selectedIdforEdit].invoice_date" class="mb-2">
                    {{ invoiceitems[selectedIdforEdit].invoice_date }}
                  </b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.invoice_due_date[dicts.lang] }}</label>
                  <b-form-datepicker today-button reset-button close-button locale="id"
                                     :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
                                     id="datepicker-due-date"
                                     v-model="invoiceitems[selectedIdforEdit].due_date" class="mb-2">
                    {{ invoiceitems[selectedIdforEdit].due_date }}
                  </b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.start_date[dicts.lang] }}</label>
                  <b-form-datepicker today-button reset-button close-button locale="id"
                                     :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
                                     id="datepicker-update-start-date-activation"
                                     @input="(e)=>{invoiceitems[selectedIdforEdit].active_date_setup=e}"
                                     :value="invoiceitems[selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_active"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.due_date[dicts.lang] }}</label>
                  <b-form-datepicker today-button reset-button close-button locale="id"
                                     :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
                                     id="datepicker-update-end-date-activation"
                                     @input="(e)=>{invoiceitems[selectedIdforEdit].due_date_setup=e}"
                                     v-model="invoiceitems[selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_due"
                                     class="mb-2">{{ invoiceitems[selectedIdforEdit].due_date_setup }}
                  </b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.hardware_price[dicts.lang] }}</label>
                  <smart-search init url="/api/master/seeker/hardware-price" usedefault
                                :default-value="invoiceitems[selectedIdforEdit].hardware_price.name_hardware_price"
                                @clear="smartSearchUpdateHardwarePrice(null)" key-tag="name_hardware_price"
                                v-on:update="(data)=>smartSearchUpdateHardwarePrice(data)"></smart-search>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.airtime_price[dicts.lang] }}</label>
                  <smart-search init url="/api/master/seeker/airtime-price" usedefault
                                :default-value="invoiceitems[selectedIdforEdit].name_airtime_price"
                                @clear="smartSearchUpdateAirtimePrice(null)" key-tag="name_airtime_price"
                                v-on:update="(data)=>smartSearchUpdateAirtimePrice(data)"></smart-search>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.discount[dicts.lang] }}</label>
                  <smart-search init url="/api/master/seeker/discount" usedefault
                                :default-value="invoiceitems[selectedIdforEdit].discount_detail!=undefined&&invoiceitems[selectedIdforEdit].discount_detail.discount"
                                key-tag="discount" @clear="smartSearchUpdateDiscount(null)"
                                v-on:update="(data)=>smartSearchUpdateDiscount(data)"></smart-search>
                </div>

                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">Total {{ dicts.discount[dicts.lang] }}</label>
                  <div class="form-control w-100 rounded">
                    {{ invoiceitems[selectedIdforEdit].discount | numeral("0,0") }}
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">Sub Total</label>
                  <div class="form-control w-100 rounded">
                    {{ invoiceitems[selectedIdforEdit].subtotal | numeral("0,0") }}
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.ppn[dicts.lang] }}</label>
                  <smart-select name="ppn" :options="ppnTypeOptions"
                                v-on:update="(value)=>{invoiceitems[selectedIdforEdit].ppn=value;$forceUpdate();calculateUpdateAmount()}"></smart-select>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">Total</label>
                  <div class="form-control w-100 rounded">
                    {{ invoiceitems[selectedIdforEdit].total | numeral("0,0") }}
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">PIC</label>
                  <input type="text" class="form-control w-100 rounded"
                         v-model="invoiceitems[selectedIdforEdit].cp"/>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.position[dicts.lang] }}</label>
                  <input type="text" class="form-control w-100 rounded"
                         v-model="invoiceitems[selectedIdforEdit].department"/>
                </div>

                <div class="col-12 mt-3">
                  <div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
                    <div class="alert alert-success" role="alert">
                      Berhasil Update Data Invoice Perangkat.
                    </div>
                  </div>
                </div>
              </div> -->
          <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
              <hr>
              <div class="col-12 mt-3">
                <div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
                  <div class="alert alert-danger" role="alert">
                    <div class="my-0">
                      <p class="d-block mt-1 text-left">Gagal update Invoice Perangkat.</p>
                    </div>
                    <div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
                      <p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 mt-3">
                <div class="d-flex align-items-center justify-content-start" v-if="updating">
                  <div class="spinner-border" role="status" aria-hidden="true"></div>
                  <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                </div>
                <button class="btn btn-info float-right" type="button" v-on:click="updateInvoiceItem">
                  {{ dicts.submit[dicts.lang] }}
                </button>
                <b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-invoice')">
                  {{ dicts.close[dicts.lang] }}
                </b-button>
              </div>
            </div>
          </template>
        </b-modal>

        <b-modal id="modal-add-invoice" title="Buat Invoice" no-close-on-backdrop size="lg"
          @hide="editModalClose" v-if="invoiceitems.length>0">
          <div class="row" v-if="invoiceitems[selectedIdforEdit]!=undefined">
            <div class="col-12 col-md-6 col-lg-4 mt-2">
              <label class="d-block">Invoice</label>
              <input type="text" class="form-control w-100 rounded" v-model="invoiceitems[selectedIdforEdit].invoice_no"/>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mt-2">
              <label class="d-block">Status</label>
              <smart-select name="status" :options="statusOptionsFull" usedefault
                :default-value="translateStatus(invoiceitems[selectedIdforEdit].status)"
                v-on:update="(value)=>{invoiceitems[selectedIdforEdit].status=value}"></smart-select>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mt-2">
              <label class="d-block">Tanggal Bayar</label>
              <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-invoice-date-update" v-model="invoiceitems[selectedIdforEdit].invoice_date" class="mb-2">{{newInvoiceLain.invoice_date}}</b-form-datepicker>
            </div>
            <!-- <div class="col-12 col-md-6 mt-2">
              <label class="d-block">Jatuh tempo</label>
              <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-due-date-update" v-model="invoiceitems[selectedIdforEdit].due_date" class="mb-2">{{newInvoiceLain.due_date}}</b-form-datepicker>
            </div> -->
            <div class="col-12 mt-2">
              <label class="d-block">Keterangan</label>
              <textarea type="text"  class="form-control w-100 rounded" v-model="invoiceitems[selectedIdforEdit].notes" />
            </div>
            <div class="col-12 mt-3">
                <div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
                    <div class="alert alert-success" role="alert">
                        Berhasil Menambahkan Invoice.
                    </div>
                </div>
            </div>
              
              <div class="col-12 mt-3">
                  <div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
                      <div class="alert alert-danger" role="alert">
                          <div class="my-0">
                              <p  class="d-block mt-1">Gagal Menyimpan Invoice Baru.</p>
                          </div>
                          <div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
                              <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-12 mt-3">
                  <div class="d-flex align-items-center justify-content-start" v-if="savingNewInvoiceLain">
                      <div class="spinner-border" role="status" aria-hidden="true"></div>
                      <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                  </div>
              </div>
          </div>
          <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
              <hr>
              <div class="col-12 mt-3">
                <div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
                  <div class="alert alert-danger" role="alert">
                    <div class="my-0">
                      <p class="d-block mt-1 text-left">Gagal update Invoice Perangkat.</p>
                    </div>
                    <div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
                      <p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 mt-3">
                <div class="d-flex align-items-center justify-content-start" v-if="updating">
                  <div class="spinner-border" role="status" aria-hidden="true"></div>
                  <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                </div>
                <button class="btn btn-info float-right" type="button" v-on:click="updateInvoiceItem">
                  {{ dicts.submit[dicts.lang] }}
                </button>
                <b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-add-invoice')">
                  {{ dicts.close[dicts.lang] }}
                </b-button>
              </div>
            </div>
          </template>
        </b-modal>

        <b-modal no-close-on-esc content-class="m-0" size="lg" title="Detail Invoice" id="modal-detail-invoice-lain"
                 scrollable no-close-on-backdrop @hide="detailModalClose">
          <b-container fluid v-if="!loadData&&invoiceitems.length>0">
            <b-row class="pt-1" v-if="invoiceitems[selectedDetail]!=undefined">
              <b-col cols="12">
                <table v-if="invoiceitems.length>0" rules="rows" class="table w-100"
                       style="overflow-x:auto;">
                  <tbody>
                  <tr>
                    <th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
                        colspan="2" scope="row">Detail Invoice
                    </th>
                  </tr>
                  <tr>
                    <th scope="row">{{ dicts.no_invoice[dicts.lang] }}</th>
                    <td><b>{{ invoiceitems[selectedDetail].invoice_no != null ? invoiceitems[selectedDetail].invoice_no : '-' }}</b></td>
                  </tr>
                  <tr>
                    <th scope="row">{{ dicts.invoice_date[dicts.lang] }}</th>
                    <td>{{ invoiceitems[selectedDetail].invoice_date | timeformat }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Proforma Invoice</th>
                    <td><b>{{ invoiceitems[selectedDetail].invoice_proforma != null ? invoiceitems[selectedDetail].invoice_proforma : '-' }}</b></td>
                  </tr>
                  <tr>
                    <th scope="row">Tanggal Proforma Invoice</th>
                    <td>{{ invoiceitems[selectedDetail].invoice_date_proforma | timeformat }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Jatuh Tempo Proforma</th>
                    <td>{{ invoiceitems[selectedDetail].due_date_proforma | timeformat }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ dicts.client[dicts.lang] }}</th>
                    <td><b>{{ invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.application.application_name : '-' }}</b></td>
                  </tr>
                  <tr>
                    <th scope="row">CID</th>
                    <td>{{ invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.application.id_client : '-' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">SN</th>
                    <td>{{ invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.id_transmitter : '-' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Mac Adress</th>
                    <td>{{ invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.mac_address : '-' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">NOC</th>
                    <td>{{ invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.noc.noc : '-' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">ODP</th>
                    <td>{{ invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.master_hardware.item : '-' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">ODP (Splitter Number)</th>
                    <td>{{ invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.master_hardware.hardware_name : '-' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Nama Admin</th>
                    <td>{{ invoiceitems[selectedDetail].admin_name != null ? invoiceitems[selectedDetail].admin_name : '-' }}</td>
                  </tr>
                  <tr>
                  </tr>
                  <tr>
                    <th scope="row">{{ dicts.notes[dicts.lang] }}</th>
                    <td>{{ invoiceitems[selectedDetail].notes != null ? invoiceitems[selectedDetail].notes : '-' }}</td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <table rules="rows" class="table w-100"
                             style="overflow-x:auto;">
                        <tbody>
                        <tr>
                          <th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
                              colspan="4" scope="row">List Item
                          </th>
                        </tr>
                        <tr>
                          <th>{{dicts.item_name[dicts.lang]}}</th>
                          <th>{{dicts.qty[dicts.lang]}}</th>
                          <!-- <td>{{dicts.price[dicts.lang]}}</td> -->
                          <td></td>
                          <th>{{dicts.total[dicts.lang]}}</th>
                        </tr>
                        <tr v-for="dataItem in invoiceitems[selectedDetail].metadata" :key="index">
                          <th>{{ dataItem.item.item_name }}</th>
                          <td>{{ dataItem.qty }}</td>
                          <!-- <td>{{ Number(dataItem.price).toLocaleString() }}</td> -->
                          <td></td>
                          <td>{{ Number(dataItem.price*dataItem.qty).toLocaleString() }}</td>
                        </tr>
                        <tr>
                          <th scope="row">{{ dicts.subtotal[dicts.lang] }}</th>
                          <td></td>
                          <td></td>
                          <td>{{ Number(invoiceitems[selectedDetail].subtotal).toLocaleString()}}</td>
                        </tr>
                        <tr>
                          <th scope="row">{{ dicts.total_ppn[dicts.lang] }}</th>
                          <td></td>
                          <td></td>
                          <td>{{ Number(invoiceitems[selectedDetail].total - invoiceitems[selectedDetail].subtotal - invoiceitems[selectedDetail].discount).toLocaleString()}}</td>
                        </tr>
                        <tr>
                          <th scope="row">{{ dicts.total[dicts.lang] }}</th>
                          <td></td>
                          <td></td>
                          <th>{{ Number(invoiceitems[selectedDetail].total).toLocaleString()}}</th>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  

                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-container>
          <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
              <hr>
              <b-button class="btn btn-secondary"
                        @click="(!deleteUserState)?$bvModal.hide('modal-detail-invoice-lain'):''">
                {{ dicts.close[dicts.lang] }}
              </b-button>
            </div>
          </template>
        </b-modal>
        
      </div>
    </div>
    
    

    <modal-delete url="/api/pemesanan/invoice-lain/" @read="()=>{console.log('modal ready')}" @result="deleteResult" :targetid="deleteId">
      Yakin mau menghapus data dengan detail berikut:<br>
      <ul>
        <li>Nomor Invoice: {{ itemToDelete.invoice_no }}</li>
      </ul>
    </modal-delete>
  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import SmartSearch from '../../components/SmartSearch.vue';
    import ModalDelete from '../../components/ModalDelete.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'smart-search':SmartSearch,
            'modal-delete':ModalDelete
        },
        data () {
            return {
                base_ppn:11,
                currentPage: 1,
                perPage: null,
                rowLimit: 10,
                nextUrl: null,
                prevUrl: null,
                role:'',
                selectedDetail:0,
                newairtimediskonlabel:'',
                newairtimepricelabel:'',
                selectedHardwareSetup:{},
                newhardwareidlabel:'',
                isMobile:false,
                itemToDelete:{},
                invoiceitems:[],
                searchValue:'',
                loadData:true,
                savingNewInvoiceLain:false,
                errorNewInvoiceLain:false,
                errorInvoiceItemList:[],
                existingClientResult:[],
                newInvoiceLainSaved:false,
                selectedTab:0,
                newHardwarePrice:0,
                newLainPrice:0,
                updateLainPrice:0,
                newDiscount:0,
                updateDiscount:0,
                selectedIdforEdit:0,
                updateSaved:false,
                errorUpdate:false,
                updating:false,
                deleteId:0,
                newBanklabel:'',
                isPaid:true,
                isUnpaid:false,
                // deleteTargetId:0,
                newInvoiceLain:{
                  items:[
                    {item_id:-1,item_name:'',qty:1,price:0}
                  ],
                  clientlabel:'',
                  client_id:0,
                  // client_name:'',
                  invoice_no:'',
                  // invoice_date:new Date(),
                  invoice_date:'',
                  due_date:'',
                  discount:0,
                  discountId :0,
                  id_bank:'',
                  label_bank:'',
                  subtotal :0,
                  total :0,
                  totalPPN :0,
                  ppn :'yes',
                  notes :'',
                  pic :'',
                  division :'',
                  invoice_proforma:'',
                  // invoice_date_proforma:new Date(),
                  invoice_date_proforma:'',
                  due_date_proforma:'',
                  status:'paid',
                  admin_name:''
                },
                formInvoiceLainActive:false,
                tableStructure:[
                    //label: nama heading, key: nama object property
                    {label:'No',key:null},
                    {
                      label: {
                        id: "Invoice",
                        en: "Invoice"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "Nama",
                        en: "Name"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "CID",
                        en: "CID"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "Item",
                        en: "Item"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "Tanggal Bayar",
                        en: "Payment Date"
                      },
                      key: null
                    },
                    // {
                    //   label: {
                    //     id: "Jatuh Tempo",
                    //     en: "Due Date"
                    //   },
                    //   key: null
                    // },
                    {
                      label: {
                        id: "Tanggal Proforma Invoice",
                        en: "Invoice Date"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "Jatuh Tempo Proforma",
                        en: "Due Date"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "Status",
                        en: "Status"
                      },
                      key: null
                    },
                    // {label:'Pemilik',key:null},
                    // {label:'NPWP',key:null},
                    // {label:'Tanggal',key:null},
                    // {label:'SAP',key:null},
                    {label:'Tindakan',key:null},
                ],
                dicts: {
                  lang: "id",
                  no_invoice: {
                    id: "Invoice",
                    en: "Invoice"
                  },
                  invoice_date: {
                    id: "Tanggal Bayar",
                    en: "Payment Date"
                  },
                  due_date: {
                    id: "Jatuh Tempo",
                    en: "Due Date"
                  },
                  client: {
                    id: "Nama",
                    en: "Name"
                  },
                  ppn: {
                    id: "PPN",
                    en: "PPN"
                  },
                  pic: {
                    id: "PIC",
                    en: "PIC"
                  },
                  division: {
                    id: "Jabatan",
                    en: "Devision"
                  },
                  item_name: {
                    id: "Nama Item",
                    en: "Item Name"
                  },
                  qty: {
                    id: "Quantity",
                    en: "Quantity"
                  },
                  price: {
                    id: "Harga",
                    en: "Price"
                  },
                  total: {
                    id: "Total",
                    en: "Total"
                  },
                  total_ppn: {
                    id: "Total PPN",
                    en: "Total PPN"
                  },
                  discount: {
                    id: "Discount",
                    en: "Discount"
                  },
                  subtotal: {
                    id: "SubTotal",
                    en: "SubTotal"
                  },
                  notes: {
                    id: "Keterangan",
                    en: "Notes"
                  },
                  submit: {
                    id: "Simpan",
                    en: "Submit"
                  },
                  close: {
                    id: "Tutup",
                    en: "Close"
                  },
                },
                proformaTypeOptions:[
                  {label:'Tidak',value:'no'},
                  {label:'Ya',value:'yes'},
                ],
                qrCodeTypeOptions:[
                  {label:'Tidak',value:'no'},
                  {label:'Ya',value:'yes'},
                ],
                ppnTypeOptions:[
                    {label:'Ya',value:'yes'},
                    {label:'Tidak',value:'no'},
                ],
                statusOptions:[
                    {label:'Paid',value:'paid'},
                    {label:'Unpaid',value:'unpaid'},
                ],
                statusOptionsFull:[
                    {label:'Unpaid',value:'unpaid'},
                    {label:'Paid',value:'paid'},
                    {label:'Cancel',value:'cancel'},
                ],
                // airtimeTypeOptions:[
                //     {label:'Ya',value:'yes'},
                //     {label:'Tidak',value:'no'},
                // ],
            }
        },
        created(){
            this.role=localStorage.getItem('role')
            this.newInvoiceLain.admin_name = localStorage.getItem("currentUser");
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            this.getInvoiceLains();
            this.getNoINvoice();
            // var newData = [];
            // for(var x=0;x<100;x++){
            //     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
            // }
            // console.log(newData);
            // this.users = newData;
            this.getSetPpn();
        },
        methods:{
            translateStatus(status){
              var label="";
              switch(status){
                  case "unpaid":
                      label = "Unpaid";
                      break;
                  case "paid":
                      label = "Paid";
                      break;
                  case "cancel":
                      label = "Cancel";
                      break;
              }
              return label;
            },
            getStatusClass(status) {
              switch(status) {
                case "unpaid":
                  return "text-danger";
                case "paid":
                  return "text-success";
                case "cancel":
                  return "text-dark";
                default:
                  return "";
              }
            },
            // getSetPpn(){
            //   axios.get(this.$baseUrl + "/api/setting?key=ppn", {
            //     "headers": {
            //       "Authorization": "Bearer " + localStorage.getItem("accessToken")
            //     }
            //   }).then((result) => {
            //     console.log(result);
            //     this.base_ppn = result.data.value;
            //     console.log(this.base_ppn);
            //   }).catch((err) => {
            //     //check if token fail
            //   });
            // },
            getNoINvoice(){
              axios.get(this.$baseUrl + "/api/pemesanan/no_invoice/invoice-lain", {
                "headers": {
                  "Authorization": "Bearer " + localStorage.getItem("accessToken")
                }
              }).then((result) => {
                console.log(result);
                this.newInvoiceLain.invoice_no = result.data.create;
              }).catch((err) => {
                //check if token fail
              });
            },
            editPreparation(index) {
              console.log("index for edit: " + index);
              this.selectedIdforEdit = index;
              console.log(this.invoiceitems[index]);
              this.cache.editItem = Object.assign({}, this.invoiceitems[index]);
              console.log(this.cache.editItem);
              console.log("edit journey start here");
            },
            editModalClose(mdl) {
              if (false) {
                console.log(this.cache.editItem);
                this.$set(this.invoiceitems, this.selectedIdforEdit, Object.assign({}, this.cache.editItem));
                this.cache.editItem = Object.assign({}, {});
                console.log(this.invoiceitems[this.selectedIdforEdit]);
                this.$forceUpdate();
                //this.$set(this.invoiceitems,this.selectedIdforEdit,this.dataEdit) //step 2 edit
                //this.dataEdit = Object.assign({},null)//step 3 edit
                if (this.updating) {
                  console.log("updating");
                  mdl.preventDefault();
                } else {
                  console.log("closing");
                  //mdl.hide('modal-edit-invoice');
                }
              }
            },
            changePage(isNext) {
              var url = (isNext ? this.nextUrl : this.prevUrl);
              let params = (new URL(url)).searchParams;
              const myParams = params.get("page");
              this.currentPage = myParams;
              var newUrl = this.$baseUrl + "/api/pemesanan/invoice-lain?limit=" + this.rowLimit + "&page=" + myParams;
              this.getInvoiceLains(newUrl);
            },
            resetNewInvoice(){
              // this.newInvoiceLain.client_name=''
              this.newInvoiceLain.invoice_no=''
              this.newInvoiceLain.invoice_date=''
              this.newInvoiceLain.due_date=''
              this.newInvoiceLain.discount=0
              this.newInvoiceLain.subtotal =0
              this.newInvoiceLain.total =0
              this.newInvoiceLain.totalPPN =0
              this.newInvoiceLain.id_bank = ''
              this.newInvoiceLain.ppn ='yes'
              this.newInvoiceLain.notes =''
              // this.newInvoiceLain.pic ='dewi'
              // this.newInvoiceLain.division ='manager finance'
              this.newInvoiceLain.invoice_proforma =''
              this.newInvoiceLain.invoice_date_proforma =''
              this.newInvoiceLain.due_date_proforma =''
              this.newInvoiceLain.status ='paid'
              this.newhardwareidlabel=''
              this.selectedHardwareSetup = {}
              this.newairtimepricelabel=''
              this.newairtimediskonlabel=''
            },
            updateInvoiceItem() {
              this.updating = true;
              this.errorUpdate = false;
              axios.put(
                this.$baseUrl + "/api/pemesanan/invoice-lain/" + this.invoiceitems[this.selectedIdforEdit].id,
                this.invoiceitems[this.selectedIdforEdit],
                {
                  headers: {
                    "Authorization": "Bearer " + localStorage.getItem("accessToken")
                  }
                }
              ).then((result) => {
                if (result.status = 200) {
                  this.updating = false;
                  this.updateSaved = true;
                  this.getInvoiceLains();
                  //step 4 edit
                  // this.dataEdit = this.invoiceitems[this.selectedIdforEdit]
                  setTimeout(() => {
                    this.updateSaved = false;
                    this.$bvModal.hide("modal-edit-invoice");
                    this.$bvModal.hide("modal-add-invoice");
                  }, 1000);
                }
                console.log(result);
              }).catch((err) => {
                //check if token fail
                if (err.response && err.response.status == 401) {
                  localStorage.removeItem("accessToken");
                  this.$router.push("/login");
                }
                this.updating = false;
                this.errorUpdate = true;
                console.log(err.response);
              });
            },
            // updateInvoiceItem() {
            //   this.updating = true;
            //   this.errorUpdate = false;
            //   axios.put(
            //     this.$baseUrl + "/api/pemesanan/invoice-lain/" + this.invoiceitems[this.selectedIdforEdit].id,
            //     this.invoiceitems[this.selectedIdforEdit],
            //     {
            //       headers: {
            //         "Authorization": "Bearer " + localStorage.getItem("accessToken")
            //       }
            //     }
            //   ).then((result) => {
            //     if (result.status = 200) {
            //       this.cache.editItem = this.invoiceitems[this.selectedIdforEdit];
            //       if (this.invoiceitems[this.selectedIdforEdit].active_date_setup != undefined) {
            //         this.invoiceitems[this.selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_active = this.invoiceitems[this.selectedIdforEdit].active_date_setup;
            //       }
            //       if (this.invoiceitems[this.selectedIdforEdit].due_date_setup != undefined) {
            //         this.invoiceitems[this.selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_due = this.invoiceitems[this.selectedIdforEdit].active_date_setup;
            //       }
            //       this.updating = false;
            //       this.updateSaved = true;
            //       //step 4 edit
            //       // this.dataEdit = this.invoiceitems[this.selectedIdforEdit]
            //       setTimeout(() => {
            //         this.updateSaved = false;
            //         this.$bvModal.hide("modal-edit-invoice");
            //       }, 1000);
            //     }
            //     console.log(result);
            //   }).catch((err) => {
            //     //check if token fail
            //     if (err.response && err.response.status == 401) {
            //       localStorage.removeItem("accessToken");
            //       this.$router.push("/login");
            //     }
            //     this.updating = false;
            //     this.errorUpdate = true;
            //     setTimeout(() => {
            //       this.errorUpdate = false;
            //     }, 1000);
            //     console.log(err);
            //   });
            // },
            
            setInvoiceLains(result){
              this.prevUrl = result.data.prev_page_url;
              this.nextUrl = result.data.next_page_url;
              this.currentPage = result.data.current_page;
              this.perPage = parseInt(result.data.per_page);
              this.invoiceitems = result.data.data;
              this.loadData=false
            },
            getInvoiceLains(url=(this.$baseUrl+'/api/pemesanan/invoice-lain?limit=' + this.rowLimit)){
                this.loadData=true
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    this.prevUrl = result.data.prev_page_url;
                    this.nextUrl = result.data.next_page_url;
                    this.currentPage = result.data.current_page;
                    this.perPage = parseInt(result.data.per_page);
                    this.invoiceitems = result.data.data;
                    this.loadData=false
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                      localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err)
                    this.loadData=false
                })
            },
            openXml()
            {
              var url = this.$baseUrl+'/api/xml/invoice-lain';
              window.open(url, "_blank");
            },
            deleteResult(deleted){
              console.log(deleted)
              if(deleted){
                this.getInvoiceLains();
              }
            },
            // getDeleteUrl(){
            //   return '/api/pemesanan/invoice/'+this.deleteTargetId;
            // },
            // deleteItem(item){
            //     this.deleteTargetId = item.id
            // },
            detailModalClose(mdl) {
              if (this.updating) {
                console.log("updating");
                mdl.preventDefault();
              } else {
                console.log("closing");
                mdl.hide("modal-detail-invoice-lain");
              }
            },
            calculateAmount(){
              this.newInvoiceLain.subtotal = 0
                this.newInvoiceLain.items.forEach((data)=>{
                  this.newInvoiceLain.subtotal = this.newInvoiceLain.subtotal + (data.qty * data.price)
                })
                this.newInvoiceLain.subtotal = this.newInvoiceLain.subtotal - this.newInvoiceLain.discount
                this.newInvoiceLain.totalPPN = 0
                if(this.newInvoiceLain.ppn == "yes"){
                  this.newInvoiceLain.totalPPN = this.newInvoiceLain.subtotal *(this.base_ppn/100);
                }
                this.newInvoiceLain.total = this.newInvoiceLain.subtotal + this.newInvoiceLain.totalPPN
                // if(this.newInvoiceLain.itemPrice>0){
                //   if(this.newDiscount.discount_type!=undefined){
                //     if(this.newDiscount.discount_type=='nominal'){
                //       this.newInvoiceLain.discount=data.price
                //     }else{
                //       if(this.newInvoiceLain.itemPrice>0){
                //         this.newInvoiceLain.discount = this.newInvoiceLain.itemPrice * this.newDiscount.price / 100
                //       }
                //     }
                //   }else{
                //     this.newInvoiceLain.discount=0
                //   }
                //     this.newInvoiceLain.subtotal = parseInt(this.newInvoiceLain.itemPrice) - parseInt(this.newInvoiceLain.discount);
                //     if(this.newInvoiceLain.ppn=="yes"){
                //         this.newInvoiceLain.total = this.newInvoiceLain.subtotal + (this.newInvoiceLain.subtotal * 0.1)
                //         this.newInvoiceLain.totalPPN =  this.newInvoiceLain.subtotal * 0.1
                //         console.log(this.totalPPN)
                //     }else{
                //       this.newInvoiceLain.total = this.newInvoiceLain.subtotal;
                //         this.newInvoiceLain.totalPPN = 0
                //     }
                // }else{
                //     this.newInvoiceLain.subtotal=0
                // }
            },
            calculateUpdateAmount(){
                if(this.invoiceitems[this.selectedIdforEdit].airtime_price>0){
                  if(this.updateDiscount.discount_type!=undefined){
                    if(this.updateDiscount.discount_type=='nominal'){
                      this.invoiceitems[this.selectedIdforEdit].discount=data.price
                    }else{
                      if(this.invoiceitems[this.selectedIdforEdit].airtime_price>0){
                        this.invoiceitems[this.selectedIdforEdit].discount = this.invoiceitems[this.selectedIdforEdit].airtime_price * this.updateDiscount.price / 100
                      }
                    }
                  }
                    this.invoiceitems[this.selectedIdforEdit].subtotal = parseInt(this.invoiceitems[this.selectedIdforEdit].airtime_price) - parseInt(this.invoiceitems[this.selectedIdforEdit].discount);
                    var ppn = 0
                    if(this.invoiceitems[this.selectedIdforEdit].ppn=="yes"){
                      ppn =  this.invoiceitems[this.selectedIdforEdit].subtotal * (this.base_ppn/100)

                    }
                      this.invoiceitems[this.selectedIdforEdit].total = this.invoiceitems[this.selectedIdforEdit].subtotal +ppn;
                    
                }else{
                    this.invoiceitems[this.selectedIdforEdit].subtotal=0
                }
            },
            updateNewIiProforma(data){
                this.newInvoiceLain.proforma=data
            },
            updateNewQrCode(data){
                this.newInvoiceLain.qrCode=data
            },
            updateNewPpn(data){
                this.newInvoiceLain.ppn=data
                this.calculateAmount()
            },
            updateStatus(data){
              this.newInvoiceLain.status = data;
              if (data === "paid" || data === "unpaid") {
                if (data === "paid") {
                  this.isPaid = true;
                  this.isUnpaid = false;
                } else if (data === "unpaid") {
                  this.isPaid = false;
                  this.isUnpaid = true;
                }
              } else {
                this.isPaid = false;
                this.isUnpaid = false;
              }
            },
            updateNewIiLain(data){
                this.newInvoiceLain.airtime=data
            },
            savenewInvoiceLain(){
                this.savingNewInvoiceLain=true
                this.errorNewInvoiceLain=false
                console.log(this.newInvoiceLain)
                if(
                  this.newInvoiceLain.client_id !='' && 
                  this.newInvoiceLain.invoiceItemMetadataId !='' && 
                  this.newInvoiceLain.startPeriod !='' && 
                  this.newInvoiceLain.total !='' &&
                  this.newInvoiceLain.subtotal !=''
                  ){
                    axios.post(this.$baseUrl+'/api/pemesanan/invoice-lain',this.newInvoiceLain,
                    {
                        'headers':
                        {
                            'Authorization':'Bearer '+localStorage.getItem('accessToken')
                        }
                    }).then((result)=>{
                        console.log(result)
                        this.savingNewInvoiceLain=false
                        this.newInvoiceLainSaved=true
                        this.resetNewInvoice()
                        this.getInvoiceLains()
                        this.getNoINvoice()
                        setTimeout(() => {
                            this.formInvoiceLainActive=false
                            this.newInvoiceLainSaved=false
                        }, 1000);
                    }).catch((err)=>{
                        //check if token fail
                        if(err.response && err.response.status==401){
                          localStorage.removeItem('accessToken')
                        this.$router.push('/login')
                        }
                        console.clear()
                        console.log(err.response)
                        this.savingNewInvoiceLain=false
                        this.errorNewInvoiceLain=true
                    })
                    }else{
                      console.log('data invalid')
                      this.errorNewInvoiceLain=true
                    }
            },
            // updateInvoiceLain(){
            //     this.updating=true
            //     this.errorUpdate=false
            //     axios.put(this.$baseUrl+'/api/pemesanan/invoice-airtime/'+this.invoiceitems[this.selectedIdforEdit].id,this.invoiceitems[this.selectedIdforEdit],
            //     {
            //       headers:{'Authorization':'Bearer '+ localStorage.getItem('accessToken')}
            //     }).then((result)=>{
            //         if(result.status=200){
            //             this.updating=false
            //             this.updateSaved=true
            //             setTimeout(() => {
            //                 this.updateSaved=false
            //                 this.$bvModal.hide('modal-edit-invoice')
            //             }, 1000);
            //         }
            //         console.log(result)
            //     }).catch((err)=>{
            //         //check if token fail
            //         if(err.response && err.response.status==401){
            //           localStorage.removeItem('accessToken')
            //         this.$router.push('/login')
            //         }
            //         this.updating=false
            //         this.errorUpdate=true
            //         console.log(err.response)
            //     })
            // },
            newUsernameChange(){
                this.newInvoiceLain.password = this.newInvoiceLain.username.toUpperCase();
            },
            deleteItem(item){
                console.log('button delete untuk user id: '+item.id)
            },
            updateUserRoleValue(newValue){
                this.newInvoiceLain.role=newValue
            },
            setNewClientId(newId){
                this.newInvoiceLain.clientId = newId;
                console.log(this.newInvoiceLain.clientId)
            },
            SmartSearchItem(data){
                this.newInvoiceLain.invoiceItemMetadataId=data.order_metadata.invoice_item_metadata.id
                this.selectedHardwareSetup=data
            },
            smartSearchBank(data)
            {
              if (data == null) {
                this.newInvoiceLain.id_bank = "";
                this.$forceUpdate();
                return;
              }
              this.newInvoiceLain.id_bank = data.id;
              this.$forceUpdate();
            },
            smartSearchHardwarePrice(data){
                // this.newInvoiceLain.price_hardware=data.id
                this.newHardwarePrice = data.price
                this.calculateAmount()
            },
            smartSearchLainPrice(data){
                this.newInvoiceLain.itemPrice=data.price
                this.newInvoiceLain.airtimeMonthDuration=data.month_duration
                this.newInvoiceLain.itemPriceId=data.id
                this.newLainPrice = data
                this.$forceUpdate()
                this.calculateAmount()
            },
            smartSearchUpdateLainPrice(data){
                this.invoiceitems[this.selectedIdforEdit].airtime_price=data.price
                this.invoiceitems[this.selectedIdforEdit].airtime_month_duration=data.month_duration
                this.invoiceitems[this.selectedIdforEdit].airtime_price_id=data.id
                this.updateLainPrice = data
                this.$forceUpdate()
                this.calculateUpdateAmount()
            },
            smartSearchDiscount(data){
              if(data==null){
                this.newInvoiceLain.discount=0
                this.newInvoiceLain.discountId=0
                this.newDiscount = {}
                this.$forceUpdate()
                return
              }
              
              this.newInvoiceLain.discountId=data.id
              this.newInvoiceLain.discount=data.price
              this.newDiscount = data
              this.$forceUpdate()
              this.calculateAmount()
            },
            smartSearchUpdateDiscount(data){
              if(data==null){
                this.invoiceitems[this.selectedIdforEdit].discount=0
                this.invoiceitems[this.selectedIdforEdit].discount_id=''
                this.updateDiscount = {}
                this.$forceUpdate()
                return
              }
              
              this.invoiceitems[this.selectedIdforEdit].discount_id=data.id
              this.invoiceitems[this.selectedIdforEdit].discount=data.price
              this.updateDiscount = data
              this.$forceUpdate()
              this.calculateUpdateAmount()
            },
            updateKapal(data){
              console.log(data.kapal_id.id)
              this.newInvoiceLain.vessel_id=data.kapal_id.id;
            },
            
        },
    }
</script>
<style scoped>
.btn {
    padding:2px 6px;
}
/* ::v-deep .modal.show .modal-dialog {
    transform: translate(0px, 10%);
}
::v-deep .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 1rem);
} */
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
    width: 50%;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.text-danger {
  color: #fff!important;
  background-color: RGBA(220,53,69,var(--bs-bg-opacity,1))!important;
  border-radius: 0.375rem;
  padding: 5px;
}

.text-success {
  color: #fff!important;
  background-color: RGBA(25,135,84,var(--bs-bg-opacity,1))!important;
  border-radius: 0.375rem;
  padding: 5px 12px;
}

.text-dark {
  color: #fff!important;
  background-color: RGBA(33,37,41,var(--bs-bg-opacity,1))!important;
  border-radius: 0.375rem;
  padding: 5px;
}
</style>
